
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genomes/[uuid]",
      function () {
        return require("private-next-pages/genomes/[uuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genomes/[uuid]"])
      });
    }
  